import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "referal-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkLoader = _resolveComponent("LinkLoader")!
  const _component_Referal = _resolveComponent("Referal")!
  const _component_ReferalSuccess = _resolveComponent("ReferalSuccess")!
  const _component_ReferalFromApps = _resolveComponent("ReferalFromApps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.referalOnlyFromApp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LinkLoader, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.userData && !_ctx.isSuccess && !_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_Referal, {
                key: 1,
                isError: _ctx.showError,
                onSubmitData: _ctx.submitData
              }, null, 8, ["isError", "onSubmitData"]))
            : _createCommentVNode("", true),
          (_ctx.isSuccess)
            ? (_openBlock(), _createBlock(_component_ReferalSuccess, {
                key: 2,
                userData: _ctx.userData,
                buttonLinks: _ctx.buttonLinks,
                onBack: _cache[0] || (_cache[0] = 
          () => {
            _ctx.isSuccess = false;
            _ctx.userData = null;
          }
        )
              }, null, 8, ["userData", "buttonLinks"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LinkLoader, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_ReferalFromApps, { buttonLinks: _ctx.buttonLinks }, null, 8, ["buttonLinks"])
        ]))
  ]))
}